(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__kkFiltroFlotante) return;
    window.__kkFiltroFlotante = true;

    var flotante = document.createElement('button');
    flotante.type = 'button';
    flotante.className = 'kk-filtro-flotante';
    flotante.hidden = true;
    flotante.textContent = 'Filtrar';
    flotante.addEventListener('click', function () {
      var original = document.querySelector('.facets-toggle__button');
      if (original) original.click();
    });

    /* La sección se vuelve a renderizar con cada filtro, así que el botón original
       se busca de nuevo cada vez en lugar de guardarlo. */
    var pendiente = false;
    function revisar() {
      pendiente = false;
      var original = document.querySelector('.facets-toggle__button');
      var visible = original && original.offsetParent !== null;
      if (!visible) {
        flotante.hidden = true;
        return;
      }
      if (!flotante.isConnected) document.body.appendChild(flotante);
      var n = document.querySelector('#filter-count-bubble-toggle .filter-count-bubble__text');
      var texto = 'Filtrar' + (n && n.textContent.trim() ? ' (' + n.textContent.trim() + ')' : '');
      if (flotante.textContent !== texto) flotante.textContent = texto;
      // 100px: con el header fijo visible, el botón original queda tapado antes de salir de la pantalla
      flotante.hidden = original.getBoundingClientRect().bottom > 100;
    }
    function programar() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(revisar);
    }
    window.addEventListener('scroll', programar, { passive: true });
    window.addEventListener('resize', programar);
    document.addEventListener('filter:update', function () { setTimeout(revisar, 1200); });
    revisar();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kk-resenas"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-resenas')) {
    customElements.define(
      'kk-resenas',
      class extends HTMLElement {
        connectedCallback() {
          this.pista = this.querySelector('.kk-resenas__pista');
          this.flechas = this.querySelectorAll('.kk-resenas__flecha');
          if (!this.pista) return;

          this.flechas.forEach((b) =>
            b.addEventListener('click', () => {
              const tarjeta = this.pista.querySelector('.kk-resena');
              const paso = tarjeta ? tarjeta.getBoundingClientRect().width + parseFloat(getComputedStyle(this.pista).columnGap || 0) : this.pista.clientWidth;
              this.pista.scrollBy({ left: paso * Number(b.dataset.dir), behavior: 'smooth' });
            })
          );

          // Tocar el texto lo despliega completo; otro toque lo vuelve a cortar
          this.pista.addEventListener('click', (e) => {
            const t = e.target.closest('.kk-resena__texto');
            if (t) t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
          });

          this.actualizar = () => {
            const max = this.pista.scrollWidth - this.pista.clientWidth - 2;
            this.flechas[0].disabled = this.pista.scrollLeft <= 2;
            this.flechas[1].disabled = this.pista.scrollLeft >= max;
          };
          this.pista.addEventListener('scroll', this.actualizar, { passive: true });
          window.addEventListener('resize', this.actualizar);
          this.actualizar();

          // Recién cuando el carrusel está por entrar en pantalla: quien no baja hasta acá no paga la consulta
          if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
            this.vigia = new IntersectionObserver(
              (entradas) => {
                if (!entradas.some((e) => e.isIntersecting)) return;
                this.vigia.disconnect();
                this.#refrescar().catch(() => {});
              },
              { rootMargin: '600px 0px' }
            );
            this.vigia.observe(this);
          }
        }
        disconnectedCallback() {
          window.removeEventListener('resize', this.actualizar);
          this.vigia?.disconnect();
        }

        /* Trae las reseñas de Judge.me (mismo endpoint y filtro que sync-resenas.mjs) y,
           si las primeras N no coinciden con las que vinieron en el HTML, rearma la pista.
           Si Judge.me no responde, quedan las del HTML. */
        async #refrescar() {
          const cantidad = Number(this.dataset.cantidad) || 12;
          const params = new URLSearchParams({
            reviews_selection: 'all',
            carousel_type: 'cards',
            star_rating: 'all',
            max_reviews: '30',
            url: 'https://kokoro.uy',
            shop_domain: 'dhphia-u1.myshopify.com',
            platform: 'shopify',
            primary_language: 'es',
            display_order: 'media_first',
          });
          const ctrl = new AbortController();
          setTimeout(() => ctrl.abort(), 8000);
          const res = await fetch('https://cdn.judge.me/reviews/reviews_for_carousel?' + params, { signal: ctrl.signal });
          if (!res.ok) return;
          const datos = await res.json();
          const nuevas = (datos.reviews || []).filter((r) => Number(r.rating) >= 4).slice(0, cantidad);
          if (!nuevas.length) return;

          const actuales = [...this.pista.querySelectorAll('.kk-resena')].map((li) => li.dataset.id);
          if (nuevas.length === actuales.length && nuevas.every((r, i) => r.uuid === actuales[i])) return;

          // Misma tarjeta que snippets/kk-resena.liquid; si se cambia una, cambiar la otra
          const esc = (s) => String(s ?? '').replace(/\s+/g, ' ').trim().replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
          const estrellas = (n) =>
            [1, 2, 3, 4, 5].map((i) => `<svg class="kk-estrella${i > n ? ' kk-estrella--vacia' : ''}" aria-hidden="true"><use href="#kk-estrella"/></svg>`).join('');
          const tarjeta = (r) => {
            const propia = r.pictures_urls?.[0]?.original;
            const base = propia
              ? propia.split('?')[0] + '?width='
              : r.product_variant_image_url
                ? r.product_variant_image_url + (r.product_variant_image_url.includes('?') ? '&' : '?') + 'width='
                : '';
            const nombre = esc(r.reviewer_name || 'Anónimo');
            const producto = esc(r.product_title);
            const n = Math.round(Number(r.rating) || 0);
            const foto = base
              ? `<img class="kk-resena__foto" src="${base}480" srcset="${base}320 320w, ${base}480 480w, ${base}640 640w" sizes="(max-width: 749px) 50vw, 240px" width="480" height="600" loading="lazy" decoding="async" alt="${propia ? `Foto de ${nombre} con ${producto}` : producto}">`
              : '';
            const verificada = r.verified_buyer
              ? '<svg class="kk-resena__verificada" viewBox="0 0 16 16" aria-label="Compra verificada" role="img"><circle cx="8" cy="8" r="8"/><path d="M4.6 8.3l2.2 2.2 4.6-4.8" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
              : '';
            return `<li class="kk-resena" data-id="${esc(r.uuid)}">${foto}<div class="kk-resena__cuerpo">
              <button type="button" class="kk-resena__texto" aria-expanded="false"><span>${esc(r.body)}</span></button>
              <div class="kk-resena__pie">
                <span class="kk-estrellas" role="img" aria-label="${n} de 5 estrellas">${estrellas(n)}</span>
                <span class="kk-resena__nombre"><span>${nombre}</span>${verificada}</span>
                ${producto ? `<a class="kk-resena__producto" href="${esc(r.product_url)}">${producto}</a>` : ''}
              </div></div></li>`;
          };

          const izquierda = this.pista.scrollLeft;
          this.pista.innerHTML = nuevas.map(tarjeta).join('');
          this.pista.scrollLeft = izquierda;
          this.actualizar();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
